<template>
  <div>
    <v-select
       :items="userList"
       :value.sync="selected"
       item-text='name'
       item-value='id'
       multiple
       readonly
       :label="label"
       v-bind='$attrs'
     >
      <template v-slot:selection="{ item, index }">
        <span v-if="index < showUser">{{ item.name }}</span>
        <!-- <v-chip v-if="index < showUser" small label color="primary" dark class="ml-0">
          <span>{{ item.name }}</span>
        </v-chip> -->
        <span
          v-if="index === showUser"
          class="grey--text text-caption"
        >
          (其他人+{{ selected.length - showUser }} )
        </span>
      </template>
      <template v-slot:prepend-inner>
        <v-menu
          transition="scale-transition"
          top
          :close-on-content-click="false"
          class="mt-0"
          :min-width="$isMobile ? '100%' : ''"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" fab v-on="on" :disabled="disabled" x-small color="blue-grey" dark class="mt-n1">
              <v-icon dark>mdi-account</v-icon>
            </v-btn>
          </template>

          <v-card :height="$isMobile ? 530 : 470" :min-width="!$isMobile ? 620: ''" class="overflow-auto">
            <v-toolbar color="primary" dark height="40">
              <v-toolbar-title class="size-13">人员选择</v-toolbar-title>
            </v-toolbar>

            <v-row>
              <v-col cols='12'>
                <div class="chip-dom">
                  <v-chip
                    v-for="(item ,idx) in selected"
                    :key="idx"
                    class="mg-c-2"
                    close
                    color="primary"
                    @click:close="closeChip(item)">
                    {{ item.name }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <div>
              <v-row>
                <v-col cols='12' md='5' class="pa-4" v-if="!$isMobile">
                  <v-tree-select
                    ref='dept'
                    path='system/dept/tree'
                    v-model="form.deptIds"
                    @on-change='changeDept'
                  />
                </v-col>
                <v-col cols='12' class="px-5" v-else>
                  <v-text-field label="用户名称回车搜索" dense @keydown="queryKeyDown()" hide-details="auto" outlined v-model="form.name"></v-text-field>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols='12' md='7' class='pt-0'>
                  <v-list v-if='items.length > 0'>
                    <template v-for="(item, index) in items">
                      <v-list-item :key="index">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.name"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox v-model="selected" multiple :value='item'></v-checkbox>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                    <v-card-text>
                      <v-row align="center" justify="end" class="mt-1" >
                        <v-pagination
                          small
                          v-model="page.current"
                          :length="page.count"
                          @input="nextPage"
                          :total-visible="5"
                        ></v-pagination>
                      </v-row>
                    </v-card-text>
                  </v-list>
                  <div v-else class="text-center size-15">
                    {{overlay ? '' : '无数据...'}}
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <v-overlay :value="overlay" absolute>
            <v-progress-circular
              indeterminate
              size="30"
            ></v-progress-circular>
          </v-overlay>
        </v-menu>
      </template>
    </v-select>
 </div>
</template>

<script>
  import { list } from '@/api/system/user.js'
  import VTreeSelect from '@/components/select/v-tree-select.vue'

  export default {
    name: 'VUserSelect',
    components: {
      VTreeSelect
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: '点击按钮选择用户'
      },
      showUser: {
        type: Number,
        default: 3
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        overlay: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          deptIds: [], // 部门ID
          name: '',
          workState: 1
        },
        uids: [], // 选中的用户ID
        selected: this.value,
        selectedUserIds: [], // 存放选中用户Id
        items: [], // 当前页用户
        userList: [], // 存放所有用户
        page: {
          total: 0,
          count: 0,
          size: 5,
          current: 1,
          orderByField: 'id',
          asc: false
        }
      }
    },
    methods: {
      clear () {
        this.selected = []
      },
      changeDept () {
        this.page.current = 1
        this.loadData()
      },
      closeChip (item) {
        this.selected.splice(this.selected.indexOf(this.selected.find((element) => element.id === item.id)), 1)
      },
      loadData () {
        Object.assign(this.pageParams, this.form)
        this.items = []
        this.overlay = true
        list(this.pageParams).then(res => {
          if (res.status === 200) {
            this.page.count = res.data.pages
            this.page.current = res.data.current
            this.page.total = res.data.total
            const this_ = this
            res.data.records.forEach(item => {
              this_.items.push({ id: item.id, name: item.name, uid: item.mdUserId })
            })
            this.selected = JSON.parse(JSON.stringify(this.selected))
            this.buildAllUser(this.items)
          }
          this.overlay = false
        })
      },
      buildAllUser (arr) {
        arr.forEach(item => {
          this.userList.pushUniqueObj(
            {
              key: item.id,
              id: item.id,
              name: item.name,
              uid: item.userId
            }
          )
        })
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.page.current = 1
          this.loadData()
        }
      },
      nextPage (current) {
        this.page.current = current
        this.loadData()
      }
    },
    watch: {
      value (obj) {
        this.selected = obj
        this.buildAllUser(obj)
      },
      selected (obj) {
        this.$emit('input', obj)
      }
    },
    computed: {
      pageParams () {
        return {
          page: {
            current: this.page.current,
            size: this.page.size,
            asc: this.page.asc
          }
        }
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>

<style >
  .v-input__append-outer{
    margin-top: -3px !important;
  }
  .chip-dom {
    border: 1px solid #e0e0e0;
    height: 80px;
    padding: 5px;
    margin: 5px 7px 0 7px;
    border-radius: 3px;
    overflow: auto;
  }
  .v-treeview-node__label{
    font-size: 13px;
  }
</style>
